'use client';

import type { IFaqCategory } from '@repo/config';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@repo/ui';

interface IFaqSectionProps {
  category: IFaqCategory;
}

export const FaqSection = ({ category }: IFaqSectionProps): React.JSX.Element => {
  return (
    <section id={category.slug} className="mb-8 scroll-mt-32">
      <h2 className="text-xl font-semibold mb-3">{category.title}</h2>
      <Accordion type="multiple" className="rounded-lg border">
        {category.items.map((item) => (
          <AccordionItem key={item.question} value={item.question}>
            <AccordionTrigger className="px-4">{item.question}</AccordionTrigger>
            <AccordionContent className="px-4 text-muted-foreground">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
